// @flow
import { BaseService } from '../base'
import { data, $user, isLoggedIn } from './model/store'
import { AVARAGE_PUPIL_AGE, PRESCHOOL_AGE } from './constants'
import { User } from './entities/user'
import type { WindowUser, ApiUserMe, ApiUserProfile } from './types'
import {
  initialize,
  updateUser,
  changeUser,
  updateProfileFx,
  getUserFx,
  getUserMeFx,
  getUserProfileFx,
  convertUserTypeFx,
  changeUserGradeFx,
  uploadAvatarFx,
  confirmEmailFx,
  changeUserSchoolEntryYearFx,
  reset,
} from './model/events'

type ServiceStore = typeof data

/**
 * Сервис юзера.
 * Содержит необходмые методы и поля для получения/вычисления тех или иных данных на основе других сторов.
 */
class UserService<T: ServiceStore> extends BaseService<T> {
  /** Инициализация стора */
  initialize = initialize

  /** Получение стора юзера */
  getUserStore = (): typeof $user => {
    return $user
  }

  /** Получение стора флага isLoggedIn */
  getIsLoggedInStore = (): typeof isLoggedIn => {
    return isLoggedIn
  }

  /** Возвращает состояние флага, залогинен ли юзер */
  isLoggedIn = (): boolean => {
    return isLoggedIn.getState()
  }

  /** Созданть экземпляр класса юзера */
  constructUser = (params: WindowUser & ApiUserMe & ApiUserProfile) => new User(params)

  /** Обновить данные юзера (например. из стора). Принимает поля Userэ'а */
  updateUser = updateUser

  /** Изменить данные юзера в сторе (принимает поля User'a) */
  changeUser = changeUser

  /** Обновить данные юзера в базе. Принимает ApiUser */
  updateProfile = updateProfileFx

  /** Запросить юзера с апи */
  getUser = getUserFx

  /** Запросить юзера с апи user/me */
  getUserMe = getUserMeFx

  /** Запросить юзера с апи user/profile */
  getUserProfile = getUserProfileFx

  /** Сменить тип юзера */
  convertUserType = convertUserTypeFx

  /** Поменять класс юзера */
  changeUserGrade = changeUserGradeFx

  /** Сменить год поступления в школу */
  changeUserSchoolEntryYear = changeUserSchoolEntryYearFx

  /** Загрузить аватар */
  uploadAvatar = uploadAvatarFx

  /** Подтвердить email */
  confirmEmail = confirmEmailFx

  /** Сброс данных юзера до дефолтных */
  reset = reset

  /**
   * Получаем подходящий год на основе класса пользователя по целям
   * @param {enum} цель запроса
   */
  getSuitableYearByGrade = (_for: 'birthdate'): number => {
    const { user } = this.getStore().getState()
    const currentYear = new Date().getFullYear()

    switch (_for) {
      case 'birthdate':
        if (!user) return 2000

        if (user.type === 'pupil') {
          return user.grade.index !== 0
            ? currentYear - user.grade.index - PRESCHOOL_AGE
            : currentYear - AVARAGE_PUPIL_AGE
        }

        return 2000

      default:
        break
    }

    return currentYear
  }
}

const uService = new UserService<ServiceStore>(data)

export { uService as UserService }
